// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/exhaust-plume-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/exhaust-plume-hazards/exhaust-plume-hazards.js';

mount([g0]);
